import { LoggingStrategy } from '@/logger/strategies';
import {LogLevel, LoggerConfig, LogContext} from '@/logger/types';

export abstract class BaseLoggingStrategy implements LoggingStrategy {
  constructor(protected config: LoggerConfig) {}

  abstract log(level: LogLevel, message: string, context?: LogContext, error?: Error): void;
  abstract isEnabled(level: LogLevel): boolean;

  protected shouldLog(level: LogLevel, minLevel: LogLevel): boolean {
    const levels = [LogLevel.DEBUG, LogLevel.INFO, LogLevel.WARN, LogLevel.ERROR, LogLevel.CRITICAL];
    return levels.indexOf(level) >= levels.indexOf(minLevel);
  }
}
